exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".singlePicture[data-v-4c55b8ca] {\n  width: 100%;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n.singlePicture .pictrueContainer[data-v-4c55b8ca] {\n  border-radius: 8px;\n  overflow: hidden;\n}\n", ""]);

// exports
